import { render, staticRenderFns } from "./SideDialogGeoRegionNew.vue?vue&type=template&id=0e2fd36a&"
import script from "./SideDialogGeoRegionNew.vue?vue&type=script&lang=js&"
export * from "./SideDialogGeoRegionNew.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogGeoRegionNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SideDialogGeoRegionNew.vue"
export default component.exports